// Switcher metadata for the Omni Command shell (EDNA-2005). Extracted from
// federation-entry.ts so the shell can build its icon rail from `meta` without
// pulling the whole Finance bundle into its initial chunk — federation-entry
// re-exports this, so the entry contract is unchanged.
import type { OmniRemoteMeta } from '@omni/objects'

export const meta: OmniRemoteMeta = {
  id: 'finance',
  label: 'Finance',
  icon: 'Banknote',
  basePath: '/finance',
  contextCardSupport: [] as const,
}
